import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";

const TotalNumberOfTenants = () => {
  const [totalNumberOfTenants, setTotalNumberOfTenants] = useState([]);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingNum, setIsLoadingNum] = useState(false);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/total-number-of-tenants`, config)
      .then((result) => {
        setTotalNumberOfTenants(result.data.totalNumber);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    if (localStorage.getItem("liveReload") === "true") {
      setIsLoading(false);
      const interval = setInterval(() => {
        setIsLoadingNum(true);
        axios
          .get(`${dashboardURL}/total-number-of-tenants`, config)
          .then((result) => {
            setTotalNumberOfTenants(result.data.totalNumber);
            setIsLoadingNum(false);
          })
          .catch((err) => console.log(err.response));
      }, 30000);
      return () => clearInterval(interval);
    } else {
      axios
        .get(`${dashboardURL}/total-number-of-tenants`, config)
        .then((result) => {
          setTotalNumberOfTenants(result.data.totalNumber);
          setIsLoading(false);
        })
        .catch((err) => console.log(err.response));
    }
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-tenant">
            <div className="dashboard-card-body-tenant-image">
              <span
                className="icon icon-tile-view"
                style={{ fontSize: 85 }}
              ></span>
            </div>
            <div className="dashboard-card-body-tenant-simpleData">
              {isLoadingNum ? <WhiteLoader /> : totalNumberOfTenants}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-tenant">
            {translator("Dashboard-TotalNumberOfTenants-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default TotalNumberOfTenants;
